import React from "react";
import i18next from "i18next";
import { useFormContext } from "react-hook-form";
import { Grid, Checkbox, FormControlLabel } from "@mui/material";
import { RuleActionParameterNames } from "services/common/RulesUtils";

const RuleReverseActionParam = ({ fieldName, readOnly = false }) => {

  const formMethods = useFormContext();
  const { setValue, getValues } = formMethods;

  return (
    <Grid item xs={12} md={4}>
      <FormControlLabel
        sx={{
          position: "relative",
          bottom: -14,
          '.MuiFormControlLabel-label': {
            fontSize: '14px',
            position: "relative",
            bottom: -1, left: -5
          }
        }}
        control={
          <Checkbox
            disabled={readOnly}
            checked={`true` === getValues(`${fieldName}.${RuleActionParameterNames.REVERSE_ACTION_EXECUTION_ACTIVATED}`)}
            onChange={(e) => {
              setValue(`${fieldName}.${RuleActionParameterNames.REVERSE_ACTION_EXECUTION_ACTIVATED}`, `${e.target.checked}`)
            }}
          />
        }
        label={i18next.t(`rules.configuration.ruleActions.fields.parameters.reverseAction.label`)}
        onClick={(e) => e.stopPropagation()}
      />
    </Grid>
  );
}

export default RuleReverseActionParam;
